import React from 'react';
import AppImage from '@/components/ui/AppImage';
import SEOHeading from '@/components/common/SEOHeading';

interface BreederStoryProps {
  story: {
    title: string;
    subtitle: string;
    mainImage: string;
    mainImageAlt: string;
    paragraphs: string[];
  };
}

const BreederStory = ({ story }: BreederStoryProps) => {
  return (
    <section className="mb-16">
      <div className="grid gap-8 lg:grid-cols-2 lg:gap-12">
        <div className="overflow-hidden rounded-xl shadow-warm-lg">
          <AppImage
            src={story.mainImage}
            alt={story.mainImageAlt}
            className="h-full w-full object-cover"
            width={600}
            height={500}
          />
        </div>

        <div className="flex flex-col justify-center">
          <SEOHeading level={1} className="mb-3">
            {story.title}
          </SEOHeading>
          <p className="mb-6 text-lg text-secondary">{story.subtitle}</p>

          <div className="space-y-4">
            {story.paragraphs.map((paragraph, index) => (
              <p key={index} className="leading-relaxed text-foreground">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BreederStory;